var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.88699 14.0233C1.66699 13.0475 1.66699 12.3092 1.66699 9.16667C1.66699 6.02417 1.66699 4.4525 2.88699 3.47667C4.10866 2.5 6.07199 2.5 10.0003 2.5C13.9287 2.5 15.8928 2.5 17.1128 3.47667C18.3337 4.4525 18.3337 6.02417 18.3337 9.16667C18.3337 12.3092 18.3337 13.0475 17.1128 14.0233C15.8937 15 13.9287 15 10.0003 15C7.90866 15 6.83366 16.4483 5.00033 17.5V14.8233C4.08866 14.6875 3.41783 14.4483 2.88699 14.0233Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 9,
    r: 1,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9,
    r: 1,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 9,
    r: 1,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuContact);
export default __webpack_public_path__ + "static/media/menu_contact.bab5cd3ef7998ff78b245a8c9da73f14.svg";
export { ForwardRef as ReactComponent };